import FeatureImage from '../Single/FeatureImage';
import TitleMeta from '../Single/TitleMeta';
import PostExcerpt from '../Single/PostExcerpt';
import PostReadMore from '../Single/PostReadMore';
import { classNames } from '../utils/functions';

const Default = ({ post, attributes, postClass }) => {
	const { subLayout } = attributes;

	const className = classNames(postClass, 'apbDefault');

	return <article className={className}>
		<FeatureImage post={post} attributes={attributes} />

		<div className='apbText'>
			<TitleMeta post={post} attributes={attributes} />

			{'title-meta' !== subLayout && <>
				<PostExcerpt post={post} attributes={attributes} />
				<PostReadMore post={post} attributes={attributes} />
			</>}
		</div>
	</article>;
};
export default Default;